import { Box, Fade } from '@mui/material'

import LoadingIndicator from '@/shared/components/LoadingIndicator'

import { useAuth } from '../hooks/useAuth'

import { NotLoggedInScreen } from './NotLoggedInScreen'

interface AuthGuardProps {
  children: React.ReactNode
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const { isAuthenticated, loading } = useAuth()

  return (
    <Box sx={{ position: 'relative', minHeight: '100vh' }}>
      <Fade
        in={loading}
        timeout={{ enter: 500, exit: 500 }}
        easing={{ enter: 'cubic-bezier(0.4, 0, 0.2, 1)', exit: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
        appear
        mountOnEnter
        unmountOnExit
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LoadingIndicator size={100} />
        </Box>
      </Fade>

      <Fade
        in={!loading && !isAuthenticated}
        timeout={{ enter: 500, exit: 500 }}
        easing={{ enter: 'cubic-bezier(0.4, 0, 0.2, 1)', exit: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
        appear
        mountOnEnter
        unmountOnExit
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            minHeight: '100vh',
          }}
        >
          <NotLoggedInScreen />
        </Box>
      </Fade>

      <Fade
        in={!loading && isAuthenticated}
        timeout={{ enter: 500, exit: 500 }}
        easing={{ enter: 'cubic-bezier(0.4, 0, 0.2, 1)', exit: 'cubic-bezier(0.4, 0, 0.2, 1)' }}
        appear
        mountOnEnter
        unmountOnExit
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            minHeight: '100vh',
          }}
        >
          {children}
        </Box>
      </Fade>
    </Box>
  )
}
